import React from 'react'
import {MealPlan} from '@findhotel/sapi'

import {Box} from '@vio/atlas/helpers/Box'
import {RefundType} from '@vio/core/src/offer/business/cancellationPenalties'
import {OfferPaymentMode} from '@vio/core/src/offer/business/offerPaymentMode'

import {CancellationLabel} from './CancellationLabel'
import {GuestLabel} from './GuestLabel'
import {Meal} from './Meal'
import {PaymentLabelType} from './PaymentLabelType'

interface OfferPerksProps {
  /** The resolved payment mode for this offer */
  paymentType: OfferPaymentMode
  /** Applies sold-out styling to visually indicate that the offer is no longer available. */
  isOfferSoldOut?: boolean
  /** Type of cancellation penalty (e.g., non-refundable, partial, free cancellation) */
  refundType: RefundType
  /** Datetime of the cancellation deadline */
  cancellationDeadline: string
  /** Timezone to display free cancellation date */
  timezone?: string
  /** Renders the cancellation label without the deadline date (free & partial refund) */
  hideCancellationDeadline?: boolean
  /** SAPI meal plan entries */
  mealPlan?: MealPlan[]
  /** Hides guest count when rule data is present */
  hideGuestCount?: boolean
  /** Guest first name, from the booked room rather than the booker */
  guestFirstName?: string
  /** Guest last name, from the booked room rather than the booker */
  guestLastName?: string
}

export const OfferPerks = ({
  paymentType,
  mealPlan,
  isOfferSoldOut = false,
  refundType,
  cancellationDeadline,
  timezone,
  hideCancellationDeadline = false,
  hideGuestCount = false,
  guestFirstName,
  guestLastName
}: OfferPerksProps) => {
  return (
    <Box display="flex" gap="s100" flexDirection="column">
      {mealPlan && mealPlan.length > 0 && (
        <Meal
          mealPlan={mealPlan}
          isOfferSoldOut={isOfferSoldOut}
          hideGuestCount={hideGuestCount}
        />
      )}
      <CancellationLabel
        refundType={refundType}
        cancellationDeadline={cancellationDeadline}
        timezone={timezone}
        isOfferSoldOut={isOfferSoldOut}
        hideDeadline={hideCancellationDeadline}
      />
      <PaymentLabelType
        paymentType={paymentType}
        isOfferSoldOut={isOfferSoldOut}
      />
      {guestFirstName && guestLastName && (
        <GuestLabel
          firstName={guestFirstName}
          lastName={guestLastName}
          isOfferSoldOut={isOfferSoldOut}
        />
      )}
    </Box>
  )
}
